



















import Vue from 'vue'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'

interface ComponentData {
  selectedItem: AdditionalFieldItem[]
}

export default Vue.extend({
  name: 'AdditionalFieldsSelectMultiple',

  props: {
    items: {
      type: Array as () => Array<AdditionalFieldItem>
    },
    defaultValue: String
  },

  data (): ComponentData {
    return {
      selectedItem: [],
    }
  },

  methods: {
    onSelectChange (item: AdditionalFieldItem[]): void {
      if(item.length > 0) {
        let value: string = ''

        item.forEach((i: AdditionalFieldItem) => {
          value = value + i.value + ','
        })

        value = value.slice(0, -1)

        const payload: AdditionalFieldItem = {
          designation: item[0].designation,
          id: item[0].id,
          value: value,
          parentType: item[0].parentType,
          componentId: item[0].componentId,
          groupId: item[0].groupId,
          project: item[0].project
        }
        this.$emit('onValueChange', payload)
      } else {
        if(this.items && this.items[0]) {
          const payload: AdditionalFieldItem = {
            designation: this.items[0].designation,
            id: this.items[0].id,
            value: "",
            parentType: this.items[0].parentType,
            componentId: this.items[0].componentId,
            groupId: this.items[0].groupId,
            project: this.items[0].project
          }
          this.$emit('onValueChange', payload)
        }
      }
    }
  },

  created () {
    if(this.defaultValue) {
      const values: string[] = this.defaultValue.split(',')

      values.forEach((value: string) => {
        const foundItem: AdditionalFieldItem | undefined = this.items.find((item: AdditionalFieldItem) => item.value === value)
        if(foundItem) {
          this.selectedItem.push({
            designation: foundItem.designation,
            id: foundItem.id,
            value: value,
            parentType: foundItem.parentType,
            componentId: foundItem.componentId,
            groupId: foundItem.groupId,
            project: foundItem.project
          })
        }
      })
    }
  }

})
